import { loadShell } from '@dia/content';

/** The ops pages in content/ops, read at build time and bundled with the app. */
export const opsContent = loadShell('ops');
